import { FC } from 'react';

import catSits from 'assets/cat_sits.png';

import { Placeholder } from '@hh.ru/magritte-ui';
import { MagnifierOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

interface VacancyListTabEmptyStateProps {
    variant: 'noVacancies' | 'noResults';
}

const TrlKeys = {
    noVacancies: 'CampaignCreationWizard.VacancySelectStep.empty',
    noResults: {
        title: 'CampaignCreationWizard.VacancySelectStep.emptySearch.title',
        description: 'CampaignCreationWizard.VacancySelectStep.emptySearch.description',
    },
};

export const VacancyListTabEmptyState: FC<VacancyListTabEmptyStateProps> = ({ variant }) => {
    const trl = useTrls();

    if (variant === 'noVacancies') {
        return (
            <Placeholder
                description={trl(TrlKeys.noVacancies)}
                gapTop={8}
                title=""
                titleProps={{
                    size: 'small',
                    Element: 'h2',
                    alignment: 'center',
                }}
                minHeight={236}
            >
                <Placeholder.Image src={catSits} width={110} />
            </Placeholder>
        );
    }

    return (
        <Placeholder
            title={trl(TrlKeys.noResults.title)}
            titleProps={{
                size: 'small',
                Element: 'h2',
                alignment: 'center',
            }}
            description={trl(TrlKeys.noResults.description)}
            gapTop={24}
            minHeight={268}
        >
            <MagnifierOutlinedSize24
                initialColor="secondary"
                borderRadius="halfHeight"
                padding={16}
                backgroundStyle="secondary"
            />
        </Placeholder>
    );
};
